import { Repository } from "@farris/devkit";

export abstract class BefRepository extends Repository<any>{
  restService: BefRestService;
}
export interface BefRestService {
  request(url: string, method: string, params?: any, options?: any, selfHandError?: boolean, ignoreError?: boolean, ignoreChanges?: boolean);
  buildRequestInfo();
}
export enum ViewType {
  day = 'day',
  week = 'week'
}